/** @file Deletes an attachment with its skin entries and deform keys (via removeEntity). */
import { defineRemove } from '../_shared/defineRemove';

/** attachment.delete: slot setup placeholders are names, so they stay (and show nothing until remapped). */
export const command = defineRemove({
  domain: 'attachment',
  kind: 'attachment',
  description: 'Delete an attachment with its skin entries and deform keys; slots keep their placeholder name (it shows nothing until a skin maps it again).',
});
